import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  Type,
  viewChild,
  ViewContainerRef,
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { type OverlayOpenProps, TessOverlayService } from '@core/overlay/overlay.service';

@Component({
  selector: 'tess-overlay',
  imports: [NgClass, NgTemplateOutlet],
  templateUrl: './overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayComponent {
  readonly #drawerService = inject(TessOverlayService);
  readonly dynamicSection = viewChild('dynamicSection', { read: ViewContainerRef });
  readonly data = signal<Omit<OverlayOpenProps<unknown>, 'component'>>(undefined);
  readonly active = signal(false);

  constructor() {
    afterRenderEffect(() => {
      if (this.#drawerService.load()) {
        const { component, bindings, ...data } = this.#drawerService.load();
        this.dynamicSection()?.createComponent(component as Type<unknown>, {
          bindings,
        });
        this.data.set(data);
        setTimeout(() => this.active.set(true), 0);
        return;
      }
      this.dynamicSection()?.clear();
      setTimeout(() => this.active.set(false), 0);
      this.data.set(undefined);
    });
  }
}
